export enum ComplianceMode {
  CurrentAndLastMonth = 'CurrentAndLastMonth',
  CurrentPeriod = 'CurrentPeriod',
}
